import { SERVER_IP, httpOption } from './Config';

export type AuthType = {
  status: 200 | 401 | 403 | 404,
  message?: string,
  Auth?: {
    _id: string,
    status: 'active' | 'stop' | 'waiting',
    display_name: string,
    expires: string,
    create_at: string,
    is_admin: boolean,
    is_email: boolean,
    type: 'tvk',
    _token: string,
  },
};

/**
 * token 을 체크한다.
 * @returns `resolve` code : 200 성공
 * @returns `reject` code : 401(토큰만료), 404(토큰 없음), 403(구매)
 */
export function asyncTokenCheck(): Promise<AuthType> {
  return new Promise((resolve, reject) => {
    window.$.ajax({
      ...httpOption,
      url: `${SERVER_IP}/cli/user/check`,
      type: 'get',
      xhrFields: {
        withCredentials: true,
      },
    })
      .done(res => {
        // console.log(`done, ${res.status}`)
        resolve({
          status: res.status,
          Auth: res.Auth,
        });
      })
      .fail(res => {
        // console.log(`fail, ${res.status}`)
        reject({
          status: res.status,
          Auth: res.responseJSON.Auth,
        });
      });
  });
}

/**
 * 로그인을 한다.
 * @param {*} id 
 * @param {*} pwd
 */
export function asyncSignIn(id, pwd): Promise<AuthType> {
  return new Promise((resolve, reject) => {
    window.$.ajax({
      url: `${SERVER_IP}/cli/user/login`,
      type: 'post',
      ...httpOption,
      data: {
        id,
        pwd,
      },
    })
      .done(res => {
        resolve({
          auth: res.Auth,
          status: res.status,
        });
      })
      .fail(res => {
        if(res.responseJSON){
          reject({
            auth: res.responseJSON.Auth,
            status: res.responseJSON.status,
          });
        } else{
          reject({
            auth: null,
            status: 404,
          });
        }
      });
  });
}
